// extracted by mini-css-extract-plugin
export var wordContainer = "_qb-0";